import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { spacing, breakpoints, fontSize, radius, colors, fonts } = redesignTheme;

export const useEditEbookStyles = makeStyles(() => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 80px)',
    overflow: 'hidden',
    backgroundColor: '#f1f1f1',
  },
  contentRow: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  canvasColumn: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: `${spacing.sm}px ${spacing.md}px`,
    position: 'relative',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.xs,
    },
  },
  canvasInner: {
    maxWidth: 800,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    position: 'relative',
  },
  navigatingOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'rgba(255,255,255,0.6)',
    backdropFilter: 'blur(2px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    pointerEvents: 'none',
    fontSize: fontSize.sm,
    color: '#555',
  },
  scrollLoader: {
    display: 'flex',
    justifyContent: 'center',
    padding: spacing.md,
  },
  coverImage: {
    width: '100%',
    display: 'block',
    borderRadius: radius.sm,
  },
  blockShell: {
    marginTop: spacing.md,
  },
  blockCard: {
    display: 'flex',
    gap: spacing.sm,
    cursor: 'pointer',
  },
  blockNumber: {
    flex: '0 0 auto',
    width: 28,
    textAlign: 'center',
    fontFamily: fonts.opensansSemiBold,
    fontSize: 15,
    color: colors.text,
    paddingTop: 4,
  },
  blockContent: {
    flex: 1,
    minWidth: 0,
    padding: spacing.md,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    border: '1px solid transparent',
  },
  blockContentSelected: {
    borderColor: colors.text,
  },
}));
